export function convertTime(hms: string): number {
  const value = hms.trim();
  if (!value) return 0;
  const parts = value.split(":").map((part) => Number(part));
  if (parts.some((part) => !Number.isFinite(part))) return 0;
  const [a = 0, b = 0, c = 0] = parts;
  if (parts.length === 1) return a; // already seconds
  if (parts.length === 2) return a * 60 + b;
  if (parts.length === 3) return a * 3600 + b * 60 + c;
  return 0;
}

export function parseVideoSourceUrl(
  path: string,
): { kbId: string; time: string } | null {
  const clean = (path.split("?")[0] ?? "").split("#")[0] ?? "";
  const segments = clean
    .replace(/^\/+|\/+$/g, "")
    .split("/")
    .filter(Boolean);
  const [prefix = "", id = "", time = ""] = segments;
  if (segments.length < 2 || prefix.toLowerCase() !== "video") return null;
  return { kbId: id.trim(), time: time.trim() };
}

export function applyVideoStartTime(
  article: HTMLElement,
  seconds: number,
): void {
  if (!Number.isFinite(seconds) || seconds <= 0) return;
  const iframe = article.querySelector<HTMLIFrameElement>("iframe");
  if (!iframe) return;
  const src = iframe.getAttribute("src") ?? "";
  if (!src || /[?&]start=/.test(src)) return; // idempotent
  const separator = src.includes("?") ? "&" : "?";
  iframe.setAttribute("src", `${src}${separator}start=${seconds}&autoplay=1`);
}

export function generateChapterLinks(article: HTMLElement, kbId: string): void {
  const body = article.querySelector<HTMLElement>(".bodytext");
  if (!body || body.dataset.chaptersApplied === "true") return; // idempotent
  const id = kbId.trim();
  const lines = body.innerHTML.split("<br>");
  const next = lines.map((line) => {
    // Re-append the <br> the split removed so each entry stays on its own line,
    // matching the legacy Video.cshtml formatting.
    if (!line.includes(" min ")) return `${line}<br>`;
    const match = line.match(/(\d+:\d+)+/);
    if (!match) return `${line}<br>`;
    const slot = match[0];
    const rest = line.replace(`${slot} min`, "");
    return `<a href='/video/${id}/${slot}/'>${slot}</a>${rest}<br>`;
  });
  body.innerHTML = next.join(" ");
  body.dataset.chaptersApplied = "true";
}
